import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-168">
      <div className="max-w-3xl mx-auto text-center" data-id="element-169">
        <div className="w-28 h-28 bg-gradient-to-br from-primary to-blue-600 rounded-full mx-auto flex items-center justify-center text-5xl shadow-[0_0_30px_rgba(59,130,246,0.4)] mb-8 border-4 border-bg-dark relative" data-id="element-170">
          <div className="absolute inset-0 rounded-full border-2 border-white/20" data-id="element-171"></div>
          🎨
        </div>

        <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-8 tracking-tight" data-id="element-172">
          A proposito di EDULABS™
        </h2>

        <div className="relative" data-id="element-173">
          <span className="absolute -top-6 -left-4 text-6xl text-primary/20 font-serif" data-id="element-174">
            "
          </span>
          <p className="text-text-main text-xl sm:text-2xl leading-relaxed italic font-medium relative z-10" data-id="element-175">
            Abbiamo creato questo sistema per trasformare l'ora di arte in un
            momento di pura magia, togliendo al docente il peso della
            pianificazione e della burocrazia. Meno stress, più bellezza.
          </p>
          <span className="absolute -bottom-10 -right-4 text-6xl text-primary/20 font-serif" data-id="element-176">
            "
          </span>
        </div>
      </div>
    </section>;
}